import { useState, useEffect } from "react";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import CardOffer, {
  CardNuevoKicker,
  isAdjudicacionCopy,
  isDisponibilidadCopy,
  isUsadoCopy,
} from "./CardOffer";
import CardBenefits from "./CardBenefits";

import checkIcon from "../../assets/check-square.png";

const MOBILE_MAX_WIDTH = 767;
const isMoneyPrice = (value = "") => /^\s*\$?\s*\d/.test(String(value));

const isDuplicatePlanTitle = (title = "", planes = []) => {
  const text = String(title || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  if (!text) return true;
  if (/^cuotas?\s+desde/.test(text)) return true;

  const price = String(planes?.[0]?.precio || "")
    .replace(/\s/g, "")
    .toLowerCase();
  if (price && text.replace(/\s/g, "").includes(price)) return true;

  return false;
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMobile;
};

const getEnabledCard = (vehiculo) => {
  const tipo = vehiculo.nombreTipo;
  const info = vehiculo.info;

  if (tipo === "convencional" && info.convencional?.habilitado) return info.convencional;
  if (tipo === "grandesclientes" && info.grandesclientes?.habilitado) return info.grandesclientes;
  if (tipo === "plan" && info.plan?.habilitado) return info.plan;
  if (tipo === "preventa" && info.preventa?.habilitado) return info.preventa;
  if (tipo === "adjudicado" && info.adjudicado?.habilitado) return info.adjudicado;
  return null;
};

const CardCta = ({ id, onClick }) => (
  <div className="card-new-vehicle-cta">
    <button type="button" className="btn-consultar-card" id={id} onClick={onClick}>
      Consultá
    </button>
  </div>
);

const VehicleTypeCard = ({ card, tipo, nombreTipo, isMobile, onConsult }) => {
  const sectionClassName = isMobile ? " card-new-vehicle--tappable" : "";
  const sectionOnClick = isMobile ? onConsult : undefined;
  const buttonOnClick = isMobile ? undefined : onConsult;
  const showEncargo = Boolean(card.entrega_por_encargo);
  const showImmediate = Boolean(
    (card.entrega_inmediata || card.disponibilidadInmediata) && !showEncargo,
  );
  const hasPlanes = Boolean(card.tipos_planes?.[0]?.nombre_plan);

  const adjudicacionInDesc = isAdjudicacionCopy(card.descripcion_titulo_principal);
  const adjudicacionInRojo = isAdjudicacionCopy(card.descripcion_rojo_titulo_principal);
  const adjudicacionInSub = isAdjudicacionCopy(card.descripcion_subtitulo_principal);
  const showAdjudicacion =
    nombreTipo === "plan" || adjudicacionInDesc || adjudicacionInRojo || adjudicacionInSub;

  const disponibilidadInDesc =
    showImmediate && isDisponibilidadCopy(card.descripcion_titulo_principal);
  const disponibilidadInRojo =
    showImmediate && isDisponibilidadCopy(card.descripcion_rojo_titulo_principal);
  const disponibilidadInSub =
    showImmediate && isDisponibilidadCopy(card.descripcion_subtitulo_principal);

  const offerDescription =
    adjudicacionInDesc || disponibilidadInDesc ? "" : card.descripcion_titulo_principal;
  const offerHighlight =
    adjudicacionInRojo || disponibilidadInRojo ? "" : card.descripcion_rojo_titulo_principal;
  const offerSubDesc =
    adjudicacionInSub || disponibilidadInSub ? "" : card.descripcion_subtitulo_principal;
  const offerTitle =
    hasPlanes && isDuplicatePlanTitle(card.titulo_principal, card.tipos_planes)
      ? ""
      : card.titulo_principal || "";
  const highlightForOffer = isUsadoCopy(offerHighlight) ? "" : offerHighlight || "";
  const showPlanExtraOffer = Boolean(
    offerTitle || offerDescription || highlightForOffer || card.soloEnMontironi,
  );

  return (
    <section
      className={`card-new-vehicle h-100 d-flex flex-column${sectionClassName}`}
      onClick={sectionOnClick}
    >
      <div className="card-new-vehicle-body">
        <div className="card-new-vehicle-header">
          <h2 className="titulo-tarjeta">{card.modelo}</h2>
          {card.version ? <h3 className="titulo-version-tarjeta">{card.version}</h3> : null}
        </div>

        <div className="card-new-vehicle-imagen">
          <img
            src={card.main_picture}
            alt={card.modelo}
            className="img-fluid"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="card-new-vehicle-footer">
          {card.preventa ? (
            <div className="vehicle-footer-entrega-inmediata">
              <p>
                <img src={checkIcon} alt="" /> PREVENTA EXCLUSIVA
              </p>
            </div>
          ) : null}

          {card.labelCheck ? (
            <div className="vehicle-footer-entrega-inmediata">
              <p
                style={{
                  fontWeight: card.labelCheck.bold,
                  color: card.labelCheck.color,
                }}
              >
                <img src={card.labelCheck.icono} alt="" />
                {card.labelCheck.texto}
              </p>
            </div>
          ) : null}

          {card.descripcion_general ? (
            <div className="vehicle-footer-descripcion-general">
              <p>{card.descripcion_general}</p>
            </div>
          ) : null}

          {card.subtitulo_principal ? (
            <div className="vehicle-footer-subtitulo-principal">
              <p>{card.subtitulo_principal}</p>
            </div>
          ) : null}

          {offerSubDesc ? (
            <div className="vehicle-footer-descripcion-subtitulo-principal">
              <p>{offerSubDesc}</p>
            </div>
          ) : null}

          {hasPlanes ? (
            <div className={card.tipos_planes.length > 1 ? "card-offer card-offer--compact" : "card-offer"}>
              {card.nuevo ? <CardNuevoKicker /> : null}
              {card.tipos_planes.map((plan, index) => (
                <div key={index} className="vehicle-footer-planes-cuotas-card">
                  <p className="card-offer-label">{plan.nombre_plan}</p>
                  <p
                    className={
                      isMoneyPrice(plan.precio)
                        ? "card-offer-number"
                        : "card-offer-number card-offer-number--text"
                    }
                  >
                    {plan.precio}
                  </p>
                  {plan.descripcion ? <p className="card-offer-headline">{plan.descripcion}</p> : null}
                </div>
              ))}
            </div>
          ) : (
            <CardOffer
              title={card.titulo_principal}
              description={offerDescription}
              highlight={offerHighlight}
              extraHighlight={card.soloEnMontironi ? "SOLO EN MONTIRONI" : ""}
              isNew={Boolean(card.nuevo)}
              plainAs="plain"
            />
          )}

          {hasPlanes && showPlanExtraOffer ? (
            <CardOffer
              title={offerTitle}
              description={offerDescription}
              highlight={offerHighlight}
              extraHighlight={card.soloEnMontironi ? "SOLO EN MONTIRONI" : ""}
              isNew={false}
              plainAs="plain"
              skipPricedDescription
              fixedSlot={false}
            />
          ) : null}
        </div>
      </div>

      <CardBenefits
        immediate={showImmediate}
        encargo={showEncargo}
        adjudicacion={showAdjudicacion}
      />
      <CardCta
        id={`${String(card.modelo || "").replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
        onClick={buttonOnClick}
      />
    </section>
  );
};

const VehicleCard = (vehiculo) => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const isMobile = useIsMobile();
  const card = getEnabledCard(vehiculo);

  const handleConsultar = (modelo, version, tipo, tipo_financiacion) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      modelo: modelo,
      version: version,
      seccion: tipo,
      event: "consultar",
      tipo_financiacion: tipo_financiacion,
    });

    openConsultaForm();
  };

  if (!card) return null;

  return (
    <div className="vehicle-card-shell h-100 d-flex w-100">
      <VehicleTypeCard
        card={card}
        tipo={vehiculo.tipo}
        nombreTipo={vehiculo.nombreTipo}
        isMobile={isMobile}
        onConsult={() =>
          handleConsultar(card.version, card.modelo, vehiculo.tipo, card.titulo_principal)
        }
      />
    </div>
  );
};

export default VehicleCard;
